export const documentTypes = {
  DEFAULT: "default",
  PLANNING: "planning",
  DIAGNOSIS: "diagnosis",
  RELATED: "related",
  SELFMONITORING: "selfmonitoring",
};
